<script>
export default {
  data() {
        return {
            addNewTagPopUp: false, // 新增商品分類 跳窗
            editVisibleDialog: false,
            editItem: {}, // 要修改的資料
            newTagTitle: '',
            tagList: [],
        }
    },
  
  async mounted() {
    await this.tryToFetchList()
  },
  methods: {
    async tryToFetchList() {
      const res = await this.$store.dispatch('mixTag/mixTagSearch', {
        search: '',
        type: 'cosmetic',
        paginate: 0,
      })
      this.tagList = res.items
    },
      // 新增商品分類
      addNewServiceTab() {
          this.addNewTagPopUp = true
      },
      /**
       * @description 打開編輯商品分類的視窗
       */
      tryToEdit(item, index) {
          try {
              this.editItem = { ...item }
              this.editVisibleDialog = true
          } catch (error) {
              console.error(error.message)
          }
      },
      /**
       * @description 驗證資料
       */
       async tryToAdd() {
        try {
          await this.$store.dispatch('mixTag/mixTagStore', {
            title: this.newTagTitle,
            type: 'cosmetic',
          })
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.newTagTitle = ''
          this.tryToFetchList()
        } catch (error) {
          console.error(error.message)
        } finally {
          this.addNewTagPopUp = false
        }
      },
      checkBeforeAdd() {
        if (this.newTagTitle === '') {
          this.$message({
            message: '請輸入標籤名稱',
            type: 'warning',
          })
          return
        }
        this.tryToAdd()
      },
      /**
       * @description 編輯商品分類 儲存
       */
      async finishEditAndSave() {
        try {
          console.log(this.editItem);
          await this.$store.dispatch('mixTag/mixTagStore', { ...this.editItem, type: 'cosmetic' })
          this.$message({
            message: '儲存成功',
            type: 'success',
          })
          this.editVisibleDialog = false
          this.tryToFetchList()
        } catch (error) {
          console.error(error.message)
          this.$message.error(error.message)
        }
      },
      async removeCosmeticTag() {
        try {
          await this.$store.dispatch('mixTag/mixTagRemove', { ids: [this.editItem.id] })
          this.tryToFetchList()
          this.editVisibleDialog = false
        } catch (error) {
          console.error(error.message)
        }
      },
  }
}
</script>

<template>
    <div :class="$style.basicSetForm">
      <h4 data-tour-text="" class="form-block-title justify-content-start fs-lg">分類設定</h4>
      <div :class="$style.mainBlock">
        <div :class="$style.mainBlock__innerMain">
          <div class="accrodion">
            <div v-for="(tag, index) in tagList" :key="tag.id">
              <div class="accrodion-item">
                <div class="accrodion-header">
                    <span style="margin-left: 14px">{{ tag.title }}</span>
                  <div class="accrodion-tooltip">
                    <el-tooltip content="編輯" placement="top">
                      <el-button class="is-no-style" @click="tryToEdit(tag, index)">
                        <BaseIcon name="edit" style="font-size: 20px; padding: 0 14px" class="text-primary" />
                      </el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.mainBlock__footer">
        <el-button class="btn-block is-round" @click="addNewServiceTab"> <BaseIcon name="plus" style="font-size: 14px; padding: 0 14px" />新增服務分類 </el-button>
      </div>
      <el-dialog :title="'編輯服務分類'" :destroy-on-close="true" :visible.sync="editVisibleDialog" top="0" width="550px" append-to-body>
        <el-form label-position="top" :model="editItem" class="el-form--floating">
          <el-form-item label="名稱" required>
            <el-input v-model="editItem.title" placeholder="請輸入分類名稱"></el-input>
          </el-form-item>
        </el-form>
        <div :class="$style.bottomBtn" class="mb-4">
          <el-button class="is-round" style="width: 50%" @click="editVisibleDialog = false">取消</el-button>
          <el-button class="is-round" style="width: 50%" type="primary" @click="finishEditAndSave">儲存變更</el-button>
        </div>
        <div :class="$style.deleteTab" @click="removeCosmeticTag">刪除分類</div>
      </el-dialog>
  
      <el-dialog :title="'新增服務分類'" :destroy-on-close="true" :visible.sync="addNewTagPopUp" top="0" width="550px" append-to-body>
        <el-form ref="newForm" label-position="top" class="el-form--floating mb-5 mb-md-0">
          <el-form-item label="服務分類名稱" required>
            <el-input v-model.trim="newTagTitle" placeholder="請輸入分類名稱" @keydown.enter.prevent></el-input>
          </el-form-item>
        </el-form>
        <div :class="$style.bottomBtn">
          <el-button class="is-round" style="width: 50%" @click="addNewTagPopUp = false">取消</el-button>
          <el-button class="is-round" style="width: 50%" type="primary" @click="checkBeforeAdd">確認</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <style lang="scss" module>
  @import '@design';
  @import '@src/design/layout_detail_steps.scss';
  
  .basicSetForm {
    :global {
      overflow: scroll;
      width: 100%;
      background-color: white;
      padding: 18px 20px 100px;
  
      .btn-block {
        display: block;
        width: 100%;
      }
  
      .accrodion {
        .show {
          display: block !important;
        }
  
        .collapse {
          display: none;
        }
  
        &-collapse {
          transition: 0.5s;
        }
  
        &-header {
          border: 1px solid #f4f4f4;
          border-radius: 8px;
          height: 50px;
          width: 100%;
          background-color: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 10px 0;
          padding: 0 18px;
  
          &:hover {
            cursor: pointer;
          }
        }
  
        &-title {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
        }
  
        &-tooltip {
          display: flex;
          align-items: center;
        }
  
        .list {
          padding-left: 22px;
  
          &-item {
            border: 1px solid #f4f4f4;
            border-radius: 8px;
            height: 50px;
            width: 100%;
            background-color: white;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 2px 0;
            padding: 0 18px;
          }
        }
      }
    }
  }
  
  .angleRotate {
    transform: rotate(90deg);
  }
  
  .mainBlock {
    background-color: $color-line;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    height: 500px;
    overflow-y: auto;
    border-radius: $border-radius;
  
    &__innerMain {
      padding: 20px;
    }
  
    &__innerMainParent {
      height: 50px;
      width: 100%;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  
    &__footer {
      background-color: $color-line;
      padding: 20px;
    }
  }
  
  .bottomBtn {
    display: flex;
  }
  .deleteTab {
    text-decoration: underline;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
  </style>
  